import { ReactElement } from "react";

export function Help(): ReactElement {
  return (
    <div className="max-w-[800px] text-gray-700">
      <h1 className="text-lg font-bold mb-2">
        Zonenplan mit / ohne Vorwirkung
      </h1>
      <p className="leading-relaxed">
        LUBAT bietet die Möglichkeit die Bauzonenkapazitäts-Kennzahlen der
        verschiedenen Zonenplanzustände (ohne Vorwirkung, mit Vorwirkung,
        rechtskräftiger Zonenplan) miteinander zu vergleichen. Der aktuell
        rechtskräftige Zonenplan befindet sich dabei bereits auf der kantonalen
        Dateninfrastruktur. Die Zonenpläne mit / ohne Vorwirkung sind vorgängig
        auf die kantonalen Dateninfrastruktur hochzuladen.
      </p>
      <p className="mt-4">Bitte gehen Sie wie folgt vor:</p>
      <ol>
        <li className="leading-relaxed my-2">
          <span className="font-bold">Schritt 1:</span> Laden Sie einen neuen
          Zonenplan mit / ohne Vorwirkung mittels bestehendem Prozess (GeoShop)
          hoch. Erfolgt der Upload vor 12:00 Uhr mittags eines Werktags, werden
          die Daten noch am selben Tag verarbeitet und stehen am nächsten
          Werktag in der LUBAT-Applikation zur Verfügung.
        </li>
        <li className="leading-relaxed my-2">
          <span className="font-bold">Schritt 2:</span> Die
          Bauzonenkapazitäts-Kennzahlen werden jeweils mittels standardisierter
          Kennwerte berechnet. Diese Kennwerte können Sie jedoch beliebig
          anpassen (z.B. um verschiedene Szenarien zu simulieren oder um die
          Kapazitäten zweier Zonenpläne miteinander zu vergleichen), speichern
          und zu einem späteren Zeitpunkt wiederverwenden.
        </li>
        <li className="leading-relaxed my-2">
          <span className="font-bold">Schritt 3:</span> Im Menüpunkt
          "Bauzonenkapazitäten vergleichen" können Sie dann zwei Zonenpläne
          auswählen und die Kapazitäten miteinander vergleichen.
          Selbstverständlich können Sie dort auch lediglich die Kapazitäten
          eines Zonenplans berechnen lassen.
        </li>
      </ol>
    </div>
  );
}
